import { I18n } from '@calendly/i18n'

import { LocationRowFallback } from './location_row_fallback'
import { PhoneCallCard } from './phone_call_card'
import { useEditableLocationItem } from './use_editable_location_item'

export const PhoneCallItem = ({
  location,
  fieldNamePrefix,
  removeLocation,
  shouldDisableOutbound,
  isReadOnly,
  isDisabled,
}) => {
  const isConfirmed = Boolean(location.kind)
  const { isEditing, isNew, startEditing, handleDone, handleCancel } = useEditableLocationItem({
    isConfirmed,
    fieldNamePrefix,
    fields: {
      kind: location.kind,
      phoneNumber: location.phoneNumber,
      additionalInfo: location.additionalInfo,
    },
    removeLocation,
  })

  if (isEditing) {
    return (
      <PhoneCallCard
        fieldNamePrefix={fieldNamePrefix}
        subtitle={isNew
          ? I18n.t('publisher.event_type_editor_crud.meeting_details.location.new_location_status')
          : undefined}
        shouldDisableOutbound={shouldDisableOutbound}
        onDelete={removeLocation}
        onCancel={handleCancel}
        onDone={handleDone}
      />
    )
  }

  return (
    <LocationRowFallback
      location={location}
      title={I18n.t('publisher.event_type_editor_crud.meeting_details.location.phone_card_title')}
      subtitle={location.phoneNumber}
      removeLocation={removeLocation}
      startEditing={startEditing}
      isReadOnly={isReadOnly}
      isDisabled={isDisabled}
    />
  )
}
